import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import base64 from "base-64";
import {
  errorAlertHandle,
  successAlertHandle,
} from "../../../../utils/utilFunctions";

export const getACLMenusActions = createAsyncThunk(
  "menu/getACLMenusActions",
  async (data, { dispatch, rejectWithValue }) => {
    try {
      const res = await axios.get(`/api/rbac/user?vendorUserId=${data}`);
      res.data["vendorUserId"] = data;
      return res.data;
    } catch (err) {
      errorAlertHandle(err, dispatch);
      return rejectWithValue(err.response.data.error);
    }
  }
);

export const getAlerts = createAsyncThunk(
  "menu/getAlerts",
  async (data, { dispatch, rejectWithValue }) => {
    try {
      const config = { headers: { "Content-Type": "application/json" } };
      const body = JSON.stringify({});
      const res = await axios.post(
        `/api/alert/filter?start=0&limit=0`,
        body,
        config
      );
      return res.data;
    } catch (err) {
      errorAlertHandle(err, dispatch);
      return rejectWithValue(err.response.data.error);
    }
  }
);

export const getGlobalSettings = createAsyncThunk(
  "menu/getGlobalSettings",
  async (_, { dispatch, rejectWithValue }) => {
    try {
      const res = await axios.get("/api/hooks?name=globalSettings");
      return res.data;
    } catch (err) {
      errorAlertHandle(err, dispatch);
      return rejectWithValue(err.response.data.error);
    }
  }
);

export const getSettings = createAsyncThunk(
  "menu/getSettings",
  async (_, { dispatch, rejectWithValue }) => {
    try {
      const res = await axios.get("/api/hooks?name=Settings");
      return res.data;
    } catch (err) {
      errorAlertHandle(err, dispatch);
      return rejectWithValue(err.response.data.error);
    }
  }
);

export const updateSettings = createAsyncThunk(
  "menu/updateSettings",
  async (data, { dispatch, rejectWithValue }) => {
    try {
      const config = { headers: { "Content-Type": "application/json" } };
      const body = JSON.stringify(data);
      const res = await axios.put("/api/hooks", body, config);
      dispatch(getGlobalSettings());
      successAlertHandle("Settings updated successfully!", dispatch);
      return res.data;
    } catch (err) {
      errorAlertHandle(err, dispatch);
      return rejectWithValue(err.response.data.error);
    }
  }
);

export const updateGrainReceipt = createAsyncThunk(
  "menu/updateGrainReceipt",
  async ({ data, resetForm }, { dispatch, rejectWithValue }) => {
    try {
      const config = { headers: { "Content-Type": "application/json" } };
      const body = JSON.stringify(data);
      const res = await axios.put("/api/proc-acct-audit/update", body, config);
      successAlertHandle(
        "Grain Receipt Account updated successfully!",
        dispatch
      );
      resetForm();
      return res.data;
    } catch (err) {
      errorAlertHandle(err, dispatch);
      return rejectWithValue(err.response.data.error);
    }
  }
);

export const updateInternalFundTransfer = createAsyncThunk(
  "menu/updateInternalFundTransfer",
  async ({ data, resetForm }, { dispatch, rejectWithValue }) => {
    try {
      const config = { headers: { "Content-Type": "application/json" } };
      const body = JSON.stringify({
        ...data,
        pin: base64.encode(data.pin),
      });
      const res = await axios.post("/api/fund-transfer", body, config);
      successAlertHandle(
        "Internal Fund Transfer updated successfully!",
        dispatch
      );
      resetForm();
      return res.data;
    } catch (err) {
      errorAlertHandle(err, dispatch);
      return rejectWithValue(err.response.data.error);
    }
  }
);

export const getFBCPaymentStatus = createAsyncThunk(
  "menu/getFBCPaymentStatus",
  async ({ data, resetForm }, { dispatch, rejectWithValue }) => {
    try {
      const res = await axios.get(`/api/ext/fbc-status?hostReference=${data}`);
      resetForm();
      return res.data;
    } catch (err) {
      errorAlertHandle(err, dispatch);
      return rejectWithValue(err.response.data.error);
    }
  }
);

export const hooksFetcher = async (name) => {
  try {
    const res = await axios.get(`/api/hooks?name=${name}`);
    return res.data;
  } catch (error) {
    console.log(error.message);
  }
};

export const getLoanSettings = createAsyncThunk(
  "menu/getLoanSettings",
  async (_, { dispatch, rejectWithValue }) => {
    try {
      const res = await axios.get("/api/vendor/loan-settings");
      return res.data;
    } catch (err) {
      errorAlertHandle(err, dispatch);
      return rejectWithValue(err.response.data.error);
    }
  }
);


export const updateLoanSettings = createAsyncThunk(
  "menu/updateLoanSettings",
  async (data, { dispatch, rejectWithValue }) => {
    try {
      const config = { headers: { "Content-Type": "application/json" } };
      const body = JSON.stringify(data);
      const res = await axios.post("/api/vendor/loan-settings", body, config);
      successAlertHandle("Loan Settings updated successfully!", dispatch);
      return res.data;
    } catch (err) {
      errorAlertHandle(err, dispatch);
      return rejectWithValue(err.response.data.error);
    }
  }
);

export const saveImportData = createAsyncThunk(
  "menu/saveImportData",
  async ({type, data}, { dispatch, rejectWithValue }) => {
    try {
      const config = { headers: { "Content-Type": "application/json" } };
      const body = JSON.stringify(data);
      const res = await axios.post(`/api/import/${type}`, body, config);
      return res.data;
    } catch (err) {
      errorAlertHandle(err, dispatch);
      return rejectWithValue(err.response.data.error);
    }
  }
);


